import { capitalize } from 'utils/capitalize';

export const getCaption = (labels: string[]) => {
  if (labels[0] && labels[1]) {
    return `${capitalize(labels[0])} | ${capitalize(labels[1])}`;
  }
  if (labels[0]) {
    return capitalize(labels[0]);
  }
  return null;
};
